import PropTypes from 'prop-types'

const Error = ({showErrors}) => (showErrors ? <div className='error-text'>Error message</div> : <noscript />)

Error.propTypes = {showErrors: PropTypes.bool}

export default Error
